<section id="secao-not-found" class="p-3">
  <div>
    <img
      class="logo-educere mt-4"
      width="200px"
      src="../../../assets/imagens/logo-educere.png"
    />
  </div>
  <div class="title mt-3">
    <h1 class="display-1 text-center">Not Found</h1>
  </div>
  <div class="descricao text-center mt-2">
    <p class="h3">
      A página requisitada não foi encontrada. Por favor volte para a página
      inicial. Atenciosamente, equipe Educere.
    </p>
  </div>
</section>
